<div class="flex flex-col gap-4">
  <div class="flex items-start gap-4">
    <div class="flex flex-col gap-4 h-full justify-start flex-1 min-w-0">
      <div class="flex items-center gap-4">
        <div class="bg-white rounded-lg">
          <p-button [label]="'Back'"
                    [severity]="'secondary'"
                    [outlined]="true"
                    [icon]="'fa fa-chevron-left'"
                    (onClick)="goBack()"
          ></p-button>
        </div>

        <div class="justify-start text-text-color text-xl font-semibold font-['Inter']">
          {{ (isPrePaid() ? 'Travel Allowance Prepayment for ' : 'Travel Allowance Approval for ') + taSubmission()?.taNumber }}
        </div>

        <div class="flex gap-1 items-center">
          @if (travellersLength() > 1) {
            <i class="fa-solid fa-users"></i>
            <div class="justify-start text-text-color text-xl font-semibold font-['Inter']">{{ taSubmission()?.primaryTraveller?.details?.name + ' (+' + (travellersLength() - 1) + ')' }}</div>
          } @else {
            <i class="fa-solid fa-user"></i>
            <div class="justify-start text-text-color text-xl font-semibold font-['Inter']">{{ taSubmission()?.primaryTraveller?.details?.name }}</div>
          }
        </div>
      </div>

      <div class="justify-start text-text-color text-sm font-semibold font-['Inter'] leading-4">{{ 'Travel Date: ' + ((taSubmission()?.startDate | date: 'dd/MM/yy') ?? '-') }}</div>

      <ta-approvals-table [taSubmission]="taSubmission()"
                          [contexts]="travelContexts"
                          heading="Travel Approvals"
      ></ta-approvals-table>
    </div>

    <div class="flex flex-col gap-2 items-end">
      <ta-cost-bubble title="Approved TA Value" [value]="currentTaValue()" severity="outlined"></ta-cost-bubble>
      <div class="w-full h-[1px] bg-surface-200"></div>
      @if (isPrePaid()) {
        <ta-cost-bubble title="Prepayment Component" titleIcon="fa-regular fa-piggy-bank text-green-700" [value]="prepaymentComponent()" severity="success"></ta-cost-bubble>
      }
      <ta-cost-bubble title="Day Trip Component" [value]="dayTripComponent()" severity="purple"></ta-cost-bubble>
    </div>
  </div>

  @if (isPrePaid()) {
    <manage-ta-day-trip-payment-table mode="prepayment" [rows]="dayTripPaymentRows()"></manage-ta-day-trip-payment-table>
  }

  <div class="h-[1px] bg-surface-200 my-[2px]"></div>

  @if (isPrePaid()){
    @if (isPrepaymentProcessed()) {
      <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">
        Prepayment processed and TA is approved, will be ready to acquit after travel occurs.
      </div>
    } @else if (canProcessPrepayment()) {
      <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">
        This TA requires prepayment processing.
      </div>
      <div class="flex flex-col gap-4">
        <p-button [severity]="'primary'" styleClass="w-64 hover:cursor" (onClick)="confirmProcessPrepayment()">
          <i class="fa-regular fa-layer-group pl-[1px]"></i>
          <span class="flex-1">Prepayment Processed</span>
        </p-button>
      </div>
    } @else {
      <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">
        Awaiting prepayment processing by Finance Unit.
      </div>
    }
    @if (canCancelPrepayment()) {
      <div class="flex flex-col gap-4">
        <p-button [severity]="'danger'" data-testId="cancel-prepayment-btn" styleClass="w-64 hover:cursor" (onClick)="confirmCancelPrepayment(isPrepaymentProcessed())">
          <i class="fa-regular fa-ban pl-[1px]"></i>
          <span class="flex-1">Cancel Prepayment</span>
        </p-button>
      </div>
    }
  } @else {
    <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">
      TA is approved, will be ready to acquit after the travel occurs.
    </div>
  }
</div>
